import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import { reducer as form } from 'redux-form'

import auth from '../auth/reducer.js'
import user from '../user/reducer'
import navigation from '../navigation/reducer.js'
import offline from '../offline/reducer.js'
import request from '../util/requestReducer.js'
import notifications from '../notifications/reducer'
import serviceDesk from '../serviceDesk/reducer'
import AccessSelfService from '../accessSelfService/reducer'
import userEmulator from '../admin/tools/userEmulator/reducer'
import appStatus from '../appStatus/reducer'

const rootReducer = combineReducers({
  routing,
  form,
  request,
  auth,
  user,
  navigation,
  offline,
  notifications,
  serviceDesk,
  AccessSelfService,
  userEmulator,
  appStatus,
})

export default rootReducer



// WEBPACK FOOTER //
// ./client/src/root/reducer.js